import { DateTime } from 'luxon';

export function calculateRemainingTimePercentage(params: {
  startDate: DateTime | undefined;
  deadlineDate: DateTime | undefined;
  now?: DateTime;
}): number | undefined {
  const { startDate, deadlineDate, now = DateTime.now() } = params;

  if (!startDate?.isValid || !deadlineDate?.isValid || !now.isValid) {
    return undefined;
  }

  const totalDurationMs = deadlineDate.toMillis() - startDate.toMillis();
  if (totalDurationMs <= 0) {
    return undefined;
  }

  const remainingDurationMs = deadlineDate.toMillis() - now.toMillis();
  const remainingPercentage = (remainingDurationMs / totalDurationMs) * 100;

  return Math.round(remainingPercentage);
}